import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { selectLocale } from 'models/localization';

import { setupI18nConfigForLocale } from './index';

declare global {
  interface Window {
    $zopim?: any;
  }
}

const ReduxLocaleObserver = () => {
  const locale = useSelector(selectLocale);
  const { i18n } = useTranslation();

  useEffect(() => {
    if (!locale) return;
    if (i18n.language !== locale) {
      i18n.changeLanguage(locale);
      setupI18nConfigForLocale(locale);
    }
    const { $zopim } = window;
    if (!$zopim) return;
    $zopim(() => {
      $zopim.livechat.setLanguage(locale);
    });
  }, [locale, i18n]);

  return null;
};

export default ReduxLocaleObserver;
